import * as React from "react";
function SvgIcLegacyLinkExternal(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.46 4.852v.75h4.17l-5.99 5.988.532.53 5.988-5.988v4.17h.75v-5.45h-5.45z"
        fill="currentColor"
      />
      <path
        d="M18.117 19.149H5.61V6.64h4.701v-.75H4.86v14.008h14.007v-5.451h-.75v4.7z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcLegacyLinkExternal;
